import { createApiSlice } from "@common";
import {
  CURD_CUSTOMERS_Category
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addCustomerCategory",
    method: "post",
    url: CURD_CUSTOMERS_Category,
    stateKey: "message",
  },
  {
    name: "getCustomerCategory",
    method: "get",
    url: CURD_CUSTOMERS_Category,
    stateKey: "data",
  },
  {
    name: "updateCustomerCategory",
    method: "put",
    url: CURD_CUSTOMERS_Category,
    stateKey: "message",
  },
  {
    name: "deleteCustomerCategory",
    method: "delete",
    url: CURD_CUSTOMERS_Category,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "customerCategory",
  apiConfig,
  customReducers,
);
const customerCategorySlice = slice;
// Export the slice's reducer
export default customerCategorySlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addCustomerCategory,
  getCustomerCategory,
  updateCustomerCategory,
  deleteCustomerCategory
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
